module.exports = __webpack_public_path__ + "img/faq-grid-05.7014d1a2.png";